<template lang="pug">
  .navigation( :open="open" )
    div.modal( @click="open = false" )
    section.navigation
      img.logo( src="@/assets/logo.png" alt="Strawberry" aria-label="Website logo" )

      .links( @click="open = false" )
        Link.header( path="/" ) about me
        
        p.header comics
          Link( 
            v-for="{ name } in comics" 
            :path="`/comic/${ name }`" 
            :key="name"
            :regex="new RegExp(`\/comic\/${ name }(\/|$)`)"
          ) {{ name }}

        //- Link.header( path="/art" ) fine art

        //- p.header code
        a.header( href="https://github.com/aerori" ) github
          //- a( href="#" ) gitlab

        Link.header( path="/contact" ) contact

    .hamburger( @click="open = !open" )
      .bar1
      .bar2
      .bar3
</template>

<style lang="sass" scoped>
  section.navigation
    padding: 25px
    width: 210px
    height: 100vh
    position: sticky
    top: 0
    left: 0
    background-color: white
    transition: transform 0.3s

  @media (max-width: 800px)
    .navigation
      .modal
        background-color: transparent
        position: fixed
        left: 0
        top: 0
        width: 100vw
        height: 100vh
        transition: background-color 0.2s
        pointer-events: none
        z-index: 1

      section
        // position: fixed
        margin-left: -210px
        pointer-events: all
        z-index: 1

      .hamburger
        pointer-events: all
        width: 70px
        height: 60px
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        position: absolute
        top: 0
        cursor: pointer
        right: 0
        z-index: 2

        *
          pointer-events: none
          position: absolute
          height: 6px
          background-color: var(--text-color)
          width: 35px
          transition: transform 0.1s, top 0.1s, bottom 0.1s

        .bar1
          top: 15px

        .bar3
          bottom: 15px

    &[open]
      .modal
        background-color: rgba(black, 0.1)
        pointer-events: all

      .hamburger
        .bar1, .bar2
          transform: rotate(45deg)
          top: auto

        .bar3
          transform: rotate(-45deg)
          bottom: auto

      section.navigation
        transform: translateX(210px)

  @media (max-width: 450px)
    .navigation
      section
        width: 100vw
        margin-left: -100vw

        .logo
          max-width: 200px

      &[open] > section
        transform: translateX(100vw)

  .logo
    width: 100%

  a, p
    display: block
    color: var(--sidebar-link)
    text-decoration: none

  a
    &:hover, &[current]
      text-decoration: underline

  .header
    font-weight: bold
    margin-top: 15px

  .header > a
    margin-left: 10px

  a[current]
    color: var(--active-link)

  .links
    pointer-events: none
    a
      pointer-events: all
</style>

<script>
  import Link from './Link'
  import { comics } from '../../config.js'

  export default {
    name: 'Navigation',

    data () {
      return {
        comics,
        open: false,
      }
    },

    components: {
      Link,
    },
  }
</script>